<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useGroupsAttrsStore } from '@/stores/groups-attrs'
import { useCarUsersStore } from '@/stores/car-users'
import Modal from '@/components/UTAModal.vue'
import checkArrayIncludes from '@/helpers/checkArrayIncludes'
import userName from '@/helpers/userName'

function checkSelected(mode) {

    let result = false
    let attrs = []

    carUsers.value.array.map(link => link.user.uuid == props.user.user.uuid ? attrs = link.attr.array : false)

    switch(mode) {

        case 'navi':         result = attrs.includes('GEODATA') ? true : false
            break

        case 'remote': result = attrs.includes('REMOTE_CONTROL') ? true : false
            break

        case 'diagnostic':      result = attrs.includes('DIAGNOSTIC') ? true : false
            break

        case 'developer':       result = checkArrayIncludes(attrs, ['COMMAND', 'FIRMWARE', 'LOGS_CAR', 'PARAM']) ? true : false
            break
    }

    return result
}

function updateAttrs(event) {

    const fields = event.target.getElementsByTagName('input')

    let data = {

        attr: {

            array: []
        },
        car: props.uuid,
        user: props.user.user.uuid
    }

    for(let field of fields) {

        if(field.type == 'checkbox' && field.checked) {

            if(field.name == 'navi')         data.attr.array.push(...attrsNavi.value)
            if(field.name == 'remote')  data.attr.array.push(...attrsRemote.value)
            if(field.name == 'diagnostic')      data.attr.array.push(...attrsDiagnostic.value)
            if(field.name == 'developer')       data.attr.array.push(...attrsDeveloper.value)
        }
    }

    carUsersStore.updateCarUsers(data).then(() => {
        emit('update-attrs')
    })    
}

const props = defineProps({
    uuid: {
        type: String,
        required: true
    },
    user: {
        type: Object,
        required: true
    },
    outerIndex: {
        type: Number,
        required: true
    }
})

const emit = defineEmits(['update-attrs'])

const translaterStore   = useTranslaterStore()
const groupsAttrsStore  = useGroupsAttrsStore()
const carUsersStore     = useCarUsersStore()

const getTranslate          = computed(() => translaterStore.getTranslate)
const attrsNavi             = computed(() => groupsAttrsStore.navi)
const attrsRemote           = computed(() => groupsAttrsStore.remote)
const attrsDiagnostic       = computed(() => groupsAttrsStore.diagnostic)
const attrsDeveloper        = computed(() => groupsAttrsStore.developer)
const carUsers              = computed(() => carUsersStore.carUsers)
const carUsersUpdateMsg     = computed(() => carUsersStore.carUsersUpdateMsg)
const carUsersDeleteProcess = computed(() => carUsersStore.carUsersDeleteProcess)
const carUsersDeleteMsg     = computed(() => carUsersStore.carUsersDeleteMsg)

const showDeleteCarUser = ref(false)
const showAttrs = ref(false)

watch(carUsersUpdateMsg, msg => {
    if('success' in msg && msg.success) {
        showAttrs.value = false
    }
})

watch(carUsersDeleteMsg, msg => {
    if('success' in msg && msg.success) {
        showDeleteCarUser.value = false
        carUsersStore.readCarUsers({ car: props.uuid, params: { 'c.limit': 6 } }).then(() => {
            emit('update-attrs')
        })
    }
})
</script>

<template>
    <div class="col-10">
        <div class="row">
            <div class="col-12 col-lg-5 uta-car-users__car-vin">
                <span class="d-inline d-lg-none uta-car-users__car-mobile-title">{{ getTranslate.USER_NAME }}: </span>
                <router-link :to="'/users/' + props.user.user.uuid" class="uta-list__item-link uta-car-users__link">
                    {{ userName(props.user.user) || getTranslate.USERS_NEW_USER }}
                </router-link>
            </div>
            <div class="col-12 col-lg-7 uta-car-users__car-model">
                <span class="d-inline d-lg-none uta-car-users__car-mobile-title">{{ getTranslate.USER_EMAIL }}: </span>
                {{ props.user.user.email }}
            </div>
        </div>
    </div>
    <div class="col-2 text-end">
        <span 
            class="p-2 material-icons uta-list__item-icon"
            :class="'accordion_' + props.user.user.uuid + outerIndex"
            @click="showAttrs = !showAttrs"
        >
            settings
        </span>
        <span
            class="p-2 material-icons uta-list__item-icon"
            :title="getTranslate.CAR_USER_DELETE"
            @click="
                showDeleteCarUser = true, 
                deleteCarUsersUuid = props.user.user.uuid
            "
        >
            delete
        </span>
    </div>
    <div class="col-12 pt-3 uta-users-group-cars__attrs attrs-list__attrs" v-if="showAttrs">
        <form @submit.prevent="updateAttrs($event)">
            
            <!-- Навигационная информация -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="navi"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('navi')"
                    :id="'users-group-cars-attr_navi-' + props.user.user.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_navi-' + props.user.user.uuid"
                >
                    {{ getTranslate.ATTR_GEODATA }}
                </label>
            </div>

            <!-- Удаленное управление -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="remote"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('remote')"
                    :id="'users-group-cars-attr_remote-' + props.user.user.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_remote-' + props.user.user.uuid"
                >
                    {{ getTranslate.ATTR_REMOTE_CONTROL }}
                </label>
            </div>

            <!-- Диагностика -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="diagnostic"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('diagnostic')"
                    :id="'users-group-cars-attr_diagnostic-' + props.user.user.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_diagnostic-' + props.user.user.uuid"
                >
                    {{ getTranslate.ATTR_DIAGNOSTIC }}
                </label>
            </div>

            <!-- Режим разработчика -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="developer"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('developer')"
                    :id="'users-group-cars-attr_developer-' + props.user.user.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_developer-' + props.user.user.uuid"
                >
                    {{ getTranslate.ATTRS_DEVELOPER }}
                </label>
            </div>

            <input type="hidden" name="user" :value="props.user.user.uuid">
            <input type="hidden" name="car" :value="props.uuid">

            <button type="submit" class="uta-btn uta-btn--main mt-3">{{ getTranslate.BTN_UPDATE }}</button>
        </form>
    </div>

    <transition name="bounce">
        <Modal 
            v-if="showDeleteCarUser"
            :header="getTranslate.CAR_USERS_DELETE"
            size="md"
            @closeModal="showDeleteCarUser = false"
        >
            <template v-slot:body>
                <form @submit.prevent="carUsersStore.deleteCarUsers({ car: props.uuid, user: props.user.user.uuid })">
                    {{ getTranslate.CAR_USERS_DELETE_DESCR }}
                    <div class="mt-5 uta-btns">
                        <button 
                            type="button" 
                            class="uta-btn" 
                            @click="showDeleteCarUser = false"
                        >
                            {{ getTranslate.BTN_CANCEL }}
                        </button>
                        <button 
                            type="submit" 
                            class="uta-btn uta-btn--main" 
                            :disabled="carUsersDeleteProcess"
                        >
                            {{ getTranslate.BTN_DELETE }}
                        </button>
                    </div>
                </form>
            </template>
        </Modal>
    </transition>

</template>
